import { API_METHOD_CONSTANTS } from '../core';

export const NOTIFICATION_CONSTANT = {
  NOTIFICATION_REPLACER: 'notification-replacer',
  NOTIFICATION_MASTER_TEMPLATE: 'notification-master-template',
  NOTIFICATION_TEMPLATE: 'notification-template',
  MODULE_ACTIVITY: 'module-activity',
  ACTIVITY_MAP: 'activity-map',
};

export const NOTIFICATION_NGRX_CONSTANT = {
  [NOTIFICATION_CONSTANT.NOTIFICATION_REPLACER]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getNotificationReplacer',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addNotificationReplacer',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification Replacer',
      SUCCESS: 'Notification Replacer added successfully',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateNotificationReplacer',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification Replacer',
      SUCCESS: 'Notification Replacer updated successfully',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getNotificationReplacerPagging',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getNotificationReplacerAll',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteNotificationReplacer',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification Replacer',
      SUCCESS: 'Notification Replacer deleted successfully',
    },
  },


  [NOTIFICATION_CONSTANT.NOTIFICATION_MASTER_TEMPLATE]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getNotificationMasterTemplate',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addNotificationMasterTemplate',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification Master Template',
      SUCCESS: 'Notification Master Template added successfully',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateNotificationMasterTemplate',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification Master Template',
      SUCCESS: 'Notification Master Template updated successfully',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getNotificationMasterTemplatePagging',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getNotificationMasterTemplateAll',
      STATE: 'publicHolidayAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteNotificationMasterTemplate',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification Master Template',
      SUCCESS: 'Notification Master Template deleted successfully',
    },
  },


  [NOTIFICATION_CONSTANT.NOTIFICATION_TEMPLATE]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getNotificationTemplate',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',

    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addNotificationTemplate',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification  Template',
      SUCCESS: 'Notification  Template added successfully',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateNotificationTemplate',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification  Template',
      SUCCESS: 'Notification  Template updated successfully',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getNotificationTemplatePagging',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getNotificationTemplateAll',
      STATE: 'publicHolidayAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteNotificationTemplate',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification  Template',
      SUCCESS: 'Notification  Template deleted successfully',
    },
  },


  [NOTIFICATION_CONSTANT.MODULE_ACTIVITY]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getModuleActivity',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',

    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addModuleActivity',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification  Activity',
      SUCCESS: 'Notification  Activity added successfully',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateModuleActivity',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification  Activity',
      SUCCESS: 'Notification  Activity updated successfully',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getModuleActivityPagging',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getModuleActivityAll',
      STATE: 'publicHolidayAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteModuleActivity',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification  Activity',
      SUCCESS: 'Notification  Activity deleted successfully',
    },
  },



  [NOTIFICATION_CONSTANT.ACTIVITY_MAP]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getNotificationActivitymap',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addNotificationActivitymap',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification  Activity Map',
      SUCCESS: 'Notification  Activity Map  added successfully',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateNotificationActivitymap',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification  Activity Map',
      SUCCESS: 'Notification  Activity Map updated successfully',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getNotificationActivitymapPagging',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getNotificationActivitymapAll',
      STATE: 'publicHolidayAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: '',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteNotificationActivitymap',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Notification  Activity Map',
      SUCCESS: 'Notification  Activity Map deleted successfully',
    },
  },
};
